.wrapper {
  padding: 16px 0;
  border-top: 1px solid var(--ed-border, #ece5d8);
  border-bottom: 1px solid var(--ed-border, #ece5d8);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text {
  color: #231e19;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.051px;
}

.price {
  display: flex;
  align-items: center;
  gap: 4px;

  p:nth-child(1) {
    color: #fffbf1;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 12px;
    font-weight: 900;
    line-height: 16px;
    letter-spacing: 0.036px;
    background: #ff8e00;
    box-shadow: 1px -3px 16px 0px rgba(255, 255, 255, 0.6) inset;
    border-radius: 24px;
    padding: 2px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  p:nth-child(2) {
    color: #7b766f;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.051px;
    text-decoration: line-through;
  }

  p:nth-child(3) {
    color: #231e19;
    font-size: 17px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.068px;
  }
}

.price.USD {
  p:nth-child(2),
  p:nth-child(3) {
    font-size: 16px;
    text-wrap-mode: nowrap;

    @media (max-width: 375px) {
      font-size: 15px;
    }
  }
}

// Dark mode
:global body.dark {
  :local {
    .text,
    .price p:nth-child(3) {
      color: #fffbf2;
    }
    .wrapper {
      border-top: 1px solid var(--ed-border, #3E3C3A);
      border-bottom: 1px solid var(--ed-border, #3E3C3A);
    }
  }
}
